import LendersAPI from '../../../../api/Finance/Lenders'
import NewLender from '../../../../components/Finance/Lender/NewLender/NewLender'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import React, { useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { checkForm } from '../../../../modules/Utils'

const api = new LendersAPI()

function NewLenderCont(props) {
  const [currentStep, setCurrentStep] = useState(0)
  const [type, setType] = useState('')
  const [member, setMember] = useState({ new: true })
  const formRef = useRef()

  function next() {
    setCurrentStep((currentStep) => currentStep + 1)
  }
  function prev() {
    setCurrentStep((currentStep) => currentStep - 1)
  }

  const [submitting, _submit] = useSubmit(api.create, true)
  async function submit() {
    const lender = await checkForm(formRef)

    const data = {
      lender,
      member,
    }
    const submitted = await _submit(data)
    if (submitted)
      props.history.replace({
        pathname: `/finance/lenders/list`,
      })
  }

  const { data: members, fetching, fetchURL } = useFetchURL(`foxxapi/members?select=_id,fn,phone,mobile,email,kind`)

  return (
    <NewLender
      {...{
        formRef,
        submitting,
        submit,
        next,
        currentStep,
        member,
        setMember,
        prev,
        type,
        setType,
        members,
        fetching,
        fetchURL,
      }}
    />
  )
}

export default withRouter(NewLenderCont)
